import { PaymentSchedule } from "@redotech/redo-model/balance/balances";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { null as zNull } from "zod";
export const getOutboundBalance = {
  name: "getOutboundBalance" as const,
  input: zNull(),
  output: z.object({
    balance: z.string(),
    paymentSchedule: createEnum(PaymentSchedule),
  }),
};
